<template>
  <div class="teacher-add-upload">
    <!-- 上传模块 -->
    <div class="upload-module">
      <div class="module-title">上传XLSX表格</div>
      <el-upload
        :on-change="onChange"
        class="upload-demo"
        drag
        :show-file-list="false"
        action="https://jsonplaceholder.typicode.com/posts/"
        multiple
        :auto-upload="false"
        accept=".xls,.xlsx"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <!-- 预览模块 -->
    <div class="preview-module">
      <div class="module-title">预览</div>
      <div class="preview-table">
        <el-table
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          :data="tableData"
        >
          <el-table-column label="#" type="index"> </el-table-column>
          <el-table-column prop="teacherName" label="姓名" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
            prop="teacherNumber"
            label="工号"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column label="手机号" prop="phone"> </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 确认上传到服务器 -->
    <div class="confirm-module">
      <div class="submit-button">
        <el-button type="primary" :loading="submitButtonLoading" @click="upload">{{
          submitButtonLoading ? "上传中" : "确认上传"
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import axios from "axios";
import { baseURL } from "@/api/request"; // 服务器地址

export default {
  data() {
    return {
      submitButtonLoading: false,
      tableData: [],
      standard: [
        {
          label: "姓名",
          field: "teacherName",
        },
        {
          label: "工号",
          field: "teacherNumber",
        },
        {
          label: "手机号",
          field: "phone",
        },
      ],
      formData: "", // 上传参数
      file: "", // 文件
    };
  },
  methods: {
    onChange(file, fileList) {
      // console.log(fileList);
      let file_type = file.name.split(".")[1];
      if (!/^(xls|xlsx)$/g.test(file_type)) {
        return this.$message.error("只能选择xlsx或xls类型文件");
      } else {
        //是xlsx，xls文件,读取文件数据
        this.file = file.raw;
        this.readFileData(file.raw, (workbook) => {
          this.readWorkbook(workbook);
        });
      }
    },
    readFileData(file) {
      const fileReader = new FileReader();
      // console.log(fileReader);
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          // console.log(ws);
          this.previewTableInit(ws);
        } catch (e) {
          // console.log(e);
          return false;
        }
      };
      fileReader.readAsBinaryString(file);
    },
    previewTableInit(unmodifiedTableData) {
      this.tableData = [];
      unmodifiedTableData.forEach((item, index) => {
        let template = {};
        for (let standardItem of this.standard) {
          template[standardItem.field] = item[standardItem.label];
        }
        this.tableData.push(JSON.parse(JSON.stringify(template)));
      });
    },
    // 上传
    upload() {
      if (this.tableData.length == 0) {
        return this.$message.error("请添加数据");
      }
      if (this.submitButtonLoading) {
        return this.$message("上传中，请勿重复点击");
      }
      this.formData = new FormData();
      this.formData.append("file", this.file);
      this.formData.append("schoolId", this.school.id);
      this.formData.append("schoolName", this.school.schoolName);
      this.formData.append("createBy", this.user.id);
      let config = {
        headers: {
          bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(`${baseURL}${this.$url.uploadTeacherExcel}`, this.formData, config)
        .then((res) => {
          // res.data 服务器返回的数据
          let data = res.data;
          // console.log(data);
          if (res.status != 200) {
            this.$message.error("上传失败");
          } else {
            if (data.code == 200) {
              this.$message.success("上传成功");
              this.$emit("uploadSuccess", data.data);
            } else if (data.code == 401 || data.code == 403) {
              // token失效
              this.$message.error("获取用户信息失败，请重新登录");
              this.$store.dispatch("user/resetToken");
              this.$router.replace({
                path: "login",
                query: { redirect: this.$router.currentRoute.fullPath },
              });
            } else {
              this.$message.error("上传失败");
            }
          }
          this.submitButtonLoading = false;
        })
        .catch((err) => {
          this.submitButtonLoading = false;
          this.$message.error("上传失败，请稍后再试");
        });
    },
    reset() {
      this.tableData = [];
      this.formData = "";
      this.file = "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "./teacher-add-upload.scss";
</style>
